
import Board from '~/components/Common/Board'

export default {
    components: { Board },
}
